import React from 'react';
import { offerAnchor } from '../../data/content';
export function OfferLink({
  children,
  label,
  className = '',
  href = offerAnchor
}: {
  children: React.ReactNode;
  label: string;
  className?: string;
  href?: string;
}) {
  return <a href={href} aria-label={label} className={`group block rounded-2xl ${className}`} data-id="element-268" data-mp="174mpfjspbv50">
      {children}
    </a>;
}